/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_TitleInputs */

const en_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Application Funnel`)
};

const de_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbungs-Funnel`)
};

const fr_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entonnoir de candidature`)
};

const es_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embudo de solicitudes`)
};

const it_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imbuto delle candidature`)
};

const nl_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatietrechter`)
};

const pl_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lejek aplikacyjny`)
};

const fi_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hakemussuppilo`)
};

const da_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgningstragt`)
};

const sv_analytics_funnel_title = /** @type {(inputs: Analytics_Funnel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökningstratt`)
};

/**
* | output |
* | --- |
* | "Application Funnel" |
*
* @param {Analytics_Funnel_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_title = /** @type {((inputs?: Analytics_Funnel_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_title(inputs)
	if (locale === "fr") return fr_analytics_funnel_title(inputs)
	if (locale === "es") return es_analytics_funnel_title(inputs)
	if (locale === "it") return it_analytics_funnel_title(inputs)
	if (locale === "nl") return nl_analytics_funnel_title(inputs)
	if (locale === "pl") return pl_analytics_funnel_title(inputs)
	if (locale === "fi") return fi_analytics_funnel_title(inputs)
	if (locale === "da") return da_analytics_funnel_title(inputs)
	if (locale === "sv") return sv_analytics_funnel_title(inputs)
	return en_analytics_funnel_title(inputs)
});